enum SceneObjectTypeEnum {
    LengthDimension = "LengthDimension",
    RefLine = "RefLine",
    TextAnnotation = "TextAnnotation",
    ChecklistItem = "ChecklistItem",
    EditHandle = "EditHandle",
    AreaAnnotation = "AreaAnnotation",
    RectangleAnnotation = "RectangleAnnotation",
    CircleAnnotation = "CircleAnnotation"
}

export default SceneObjectTypeEnum;